<template>
  <div class="block galleryBlock">
    <v-container>
      <h2 class="text-center white--text"><strong>Developmenet Technologies I am familiar With</strong> </h2>
      <v-row>
        <v-col v-for="item in webs" :key="item.id" class="d-flex child-flex" cols="6" sm="4">
          <v-card flat tile class="d-flex">
            <v-img :src="item.src" aspect-ratio="1.5" class="grey lighten-2">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
     <v-container>
      <h2 class="text-center white--text"><strong>Mobile App Technologies I am familiar With</strong></h2>
      <v-row>
        <v-col v-for="mobile in mobiles" :key="mobile.id" class="d-flex child-flex" cols="6" sm="4">
          <v-card flat tile class="d-flex">
            <v-img :src="mobile.src" aspect-ratio="1" class="grey lighten-2">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
     <v-container>
      <h2 class="text-center white--text"><strong>Deployment Tools</strong></h2>
      <v-row>
        <v-col v-for="d in deployment" :key="d.id" class="d-flex child-flex" cols="6" sm="4">
          <v-card flat tile class="d-flex">
            <v-img :src="d.src" aspect-ratio="3" class="grey lighten-2">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Technologies",
  data() {
    return {
      webs: [
        {
          id: 1,
          src: require("../assets/images/frontend-tech.jpg")
        },
        {
          id: 2,
          src: require("../assets/images/mern_stack.jpg")
        },
        {
          id: 3,
          src: require("../assets/images/mevn.png")
        },
         {
          id: 4,
          src: require("../assets/images/vue_vuetify.jpg")
        },
        {
          id: 5,
          src: require("../assets/images/material.png")
        },
         {
          id: 6,
          src: require("../assets/images/c_c++_python.jpeg")
        },
        
      ],
      mobiles:[
         {
          id: 1,
          src: require("../assets/images/mobile_app.png")
        },
      ],
      deployment:[
         {
          id: 1,
          src: require("../assets/images/deployment.png")
        },
      ]
    };
  }
};
</script>